// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1JzJe","head":"ProcedureTableInfo_head__3NvbJ"};